<header>
  <opac-skeleton class="fake-title"></opac-skeleton>
  <opac-skeleton class="fake-date"></opac-skeleton>
</header>

<article *ngFor="let i of [1, 2, 3, 4]">
  <div>
    <opac-skeleton class="fake-cover"></opac-skeleton>
    <opac-skeleton class="fake-progress"></opac-skeleton>
  </div>
  <div>
    <opac-skeleton class="fake-event"></opac-skeleton>
    <opac-skeleton class="hide-tablet" style="width: 188px; height: 12px"></opac-skeleton>
  </div>
</article>
